
    import * as React from 'react';

    const Image20 = ({ color = 'currentcolor', height = '20px', width = '20px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 20 20" fill="none" style={svgStyle}><circle cx={14} cy={3} r={1.5} stroke="black" /><path d="M1 15L6 5.5L11.5 12L14.1143 8.5L18 15H14.1143H1Z" /><path d="M11.5 12L6 5.5L1 15H14.1143M11.5 12L14.1143 8.5L18 15H14.1143M11.5 12L14.1143 15" stroke="black" /></svg>
        </div>
      );
    };

    Image20.displayName = 'Image20';

    export default Image20;
  